<template>
    <div class="mainContainer">
        <div class="suggestionContainer" :class="{ open: open }">
            <span class="autoCompleteHeader" v-if="title">{{ title }}</span>
            <ul v-if="matches.length > 0">
                <li v-for="(suggestion, index) in matches" :key="suggestion.id" :class="{ 'active': isActive(index) }"
                    @click="click(index)">

                    <i>{{ suggestion.key.substr(0, 1) }}</i>
                    <span>{{ suggestion.key.substr(1) }}</span>
                    <a>{{ suggestion.value }}</a>

                </li>
            </ul>

            <ul v-if="matches.length === 0">
                <li class="no-results">
                    Nessun risultato trovato
                </li>
            </ul>

        </div>

        <input type="text" ref="input" placeholder="Scrivi il tuo messaggio..." :value="value" @input='change'
            @keydown.enter="select" @keydown.down.prevent="down" @keydown.up.prevent="up" @focus="sendStart"/>
    </div>
</template>

<script>
import { MAX_RESULTS } from '@/utils/constants.js'
/* eslint-disable no-console */
export default {
    name: 'chatinput',
    props: {
        value: String,
        autocomplete: Object,
    },
    data() {
        return {
            title: '',
            filter: false,
            current: 0,
            items: [],
        }
    },
    computed: {
        matches() {
            if (this.filter) {
                return this.binarySearch(this.items, this.filter)
            }
            return false
        },
        open() {
            return this.filter !== false
        }
    },
    created() {
        let self = this

        self.items = this.autocomplete.items.sort(function (a, b) {
            return a.key.localeCompare(b.key)
        })

    },
    methods: {
        binarySearch(items, filter) {

            filter = filter.toLowerCase();

            let startIndex = 0
            let stopIndex = items.length - 1

            let middle = 0
            let itemKey = items[middle].key.substr(0, filter.length).toLowerCase();

            if (itemKey != filter) {
                middle = Math.floor((stopIndex + startIndex) / 2)

                itemKey = items[middle].key.substr(0, filter.length).toLowerCase();

                while (itemKey != filter && startIndex < stopIndex) {
                    itemKey = items[middle].key.substr(0, filter.length).toLowerCase();
                    if (filter < itemKey) {
                        stopIndex = middle - 1
                    } else if (filter > itemKey) {
                        startIndex = middle + 1
                    }
                    middle = Math.floor((stopIndex + startIndex) / 2)
                }

                itemKey = items[middle].key.substr(0, filter.length).toLowerCase();
            }

            if (itemKey == filter) {

                let results = []

                for (let i = middle; i >= 0; i--) {
                    itemKey = items[i].key.substr(0, filter.length).toLowerCase();
                    if (itemKey == filter) {
                        results.unshift(items[i])
                        if (results.length >= MAX_RESULTS) {
                            return results
                        }
                    }
                }

                for (let i = middle + 1; i < items.length; i++) {
                    itemKey = items[i].key.substr(0, filter.length).toLowerCase();
                    if (itemKey == filter) {
                        results.push(items[i])
                        if (results.length >= MAX_RESULTS) {
                            return results
                        }
                    }
                }

                return results
            }

            return []
        },

        //When enter pressed on the input
        select() {
            if (this.filter) {
                event.preventDefault()
                if (this.current < this.matches.length) {

                    let input = this.$refs.input

                    let replace = this.matches[this.current].key

                    let start = this.value.lastIndexOf(this.filter, input.selectionStart)
                    let end = this.value.indexOf(' ', input.selectionStart)

                    let prefix = this.value.substr(0, start)
                    let postfix = (end > -1) ? ' ' + this.value.substr(end + 1) : ' '

                    let newValue = prefix + replace + postfix
                    this.$emit('input', newValue)

                    input.selectionStart = start + replace.length

                    this.filter = false
                }
            }
        },

        // When cursor is moved up
        up: function () {
            if (this.current > 0) {
                this.current--
            }
        },

        // When cursor is moved down
        down: function () {
            if (this.current < this.autocomplete.items.length - 1) {
                this.current++
            }
        },

        //For highlighting element
        isActive(index) {
            return (index === this.current)
        },

        //When one of the suggestion is clicked
        click(index) {
            this.current = index
            this.select()
        },

        //When the user changes input
        change() {
            this.$emit('input', event.target.value)
            this.filter = this.calculateFilter(event.target.value)
        },

        calculateFilter(value) {

            if (this.items.length === 0) {
                return false
            }

            let prevChar = null
            let prefix = null
            let lastPrefix = null
            let input = this.$refs.input
            let current = value.substr(0, input.selectionStart)
            let lastSpace = current.lastIndexOf(' ')

            for (let i = 0; i < this.autocomplete.prefixes.length; i++) {
                prefix = this.autocomplete.prefixes[i]
                lastPrefix = current.lastIndexOf(prefix.key)
                prevChar = (lastPrefix == 0) ? '' : current.substr(lastPrefix - 1, 1).trim();

                // If there's a prefix AND the prefix is attached to the current string (or the current string is the first string of the input) AND the previous char is a space
                if ((lastPrefix > -1) && (lastPrefix > lastSpace) && (prevChar == '')) {
                    this.title = prefix.value
                    return current.substr(lastPrefix)
                }
            }

            return false
        },
        sendStart() {
            this.$root.$emit('sendStart');
        }
    }
};
</script>

<style lang="scss">
.mainContainer {
    position: relative;

    &.isSpeechToTextAvailable {
        input {
            width: calc(100% - 135px);
        }
    }
}

input {
    border-radius: 25px;
    border: 1px solid #c1c1c1;
    padding: 4px 14px;
    width: calc(100% - 92px);
    height: 40px;
    float: left;

    &:focus {
        outline: none;
    }
}

.suggestionContainer {
    position: absolute;
    bottom: 5px;
    background: #fff;
    width: 90%;
    list-style: none;
    margin: 0;
    left: 0;
    -webkit-box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, .3);
    box-shadow: 0px 0px 9px -2px rgba(0, 0, 0, .3);
    border-radius: 10px;
    max-height: 220px;
    overflow-y: hidden;
    display: none;

    &.open {
        display: block;
    }

    .autoCompleteHeader {
        background: #f2f2f2;
        width: 100%;
        display: block;
        padding: 7px 15px;
    }

    ul {
        max-height: 175px;
        overflow-y: scroll;
        list-style: none;
        padding: 0px;
        margin: 0px;
    }

    li {
        padding: 8px 10px;
        cursor: pointer;

        &.active,
        &:hover {
            background: rgba(0, 0, 0, .1);
        }

        &.no-results {
            cursor: default;

            &:hover {
                background: initial;
            }
        }
    }

    a {
        color: #6a6a6a;
    }

    span {
        margin-right: 5px;
        font-weight: 700;
    }

    i {
        text-align: center;
        padding: 0px 3px 3px 0px;
        background: #3c4e60;
        border-radius: 4px;
        display: inline-block;
        width: 25px;
        height: 25px;
        margin-right: 6px;
        color: #fff;
    }
}
</style>